module.exports = __webpack_public_path__ + "static/media/logout.1368fd3e.svg";